import { useState } from "react";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickEntry from "@/pages/home/components/CategoryQuickEntry";
import LatestUpdates from "@/pages/home/components/LatestUpdates";
import NewsSidebar from "@/pages/home/components/NewsSidebar";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { getFeaturedComics } from "@/utils/comic";

export default function Home() {
  const featured = getFeaturedComics();
  const [activeTab, setActiveTab] = useState("全部");

  return (
    <>
      <HeroCarousel comics={featured} />
      <CategoryQuickEntry />

      <section className="w-full px-4 md:px-6 py-10 md:py-12 bg-background-100">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:flex-1 min-w-0">
            <LatestUpdates activeTab={activeTab} onTabChange={setActiveTab} />
          </div>
          <div className="w-full lg:w-[340px] shrink-0">
            <NewsSidebar />
          </div>
        </div>
      </section>

      <SiteIntro />
    </>
  );
}